import { render, staticRenderFns } from "./Swagger.vue?vue&type=template&id=6842ebdc&scoped=true"
import script from "./Swagger.vue?vue&type=script&lang=js"
export * from "./Swagger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6842ebdc",
  null
  
)

export default component.exports